import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { tr } from "../contexts/LangContext";

/* PartnersCarousel — iter 29
 * Auto-scrolling marquee of partner logos rendered just above the Footer on every page.
 * Source: /api/partners (admin-editable in /admin → Partenaires). Pure CSS infinite scroll.
 */
export default function PartnersCarousel() {
  const [partners, setPartners] = useState([]);
  const backend = process.env.REACT_APP_BACKEND_URL;
  const fullUrl = (u) => (u && u.startsWith("/uploads/") ? `${backend}/api${u}` : u);

  useEffect(() => {
    api.get("/partners").then(({ data }) => setPartners(data || [])).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  // Duplicate the list so the marquee can loop seamlessly
  const loop = [...partners, ...partners];

  return (
    <section className="bg-white border-t border-b border-slate-200 py-8 overflow-hidden" data-testid="partners-carousel">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-5">{tr("Avec le soutien de")}</div>
        <div className="relative">
          <div
            className="flex gap-12 items-center marquee-track"
            style={{ animation: "rycmMarquee 30s linear infinite" }}
            data-testid="partners-track"
          >
            {loop.map((p, i) => {
              const inner = (
                <img
                  src={fullUrl(p.logo_url)}
                  alt={p.name}
                  className="h-14 md:h-16 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
                  loading="lazy"
                  onError={(e) => { e.target.style.opacity = "0"; }}
                />
              );
              return (
                <div
                  key={`${p.id}-${i}`}
                  className="shrink-0"
                  data-testid={i < partners.length ? `partner-${p.id}` : undefined}
                >
                  {p.link_url ? (
                    <a href={p.link_url} target="_blank" rel="noopener noreferrer" title={p.name}>{inner}</a>
                  ) : inner}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes rycmMarquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .marquee-track:hover { animation-play-state: paused !important; }
      `}</style>
    </section>
  );
}
